module.exports = __webpack_public_path__ + "img/bripl-logo.78420625.png";